import lodash from 'lodash';
import {composeReducers} from 'common/util/composeReducers';
import {ACTIONS} from 'part11/actions/groups';

export function loadGroupsInScene(state, action) {
    if (!action || (
        action.type !== ACTIONS.PART11_INITIALIZE_GROUP_SCENE_COMPLION
        && action.type !== ACTIONS.PART11_UPDATE_GROUP_PRIORITY
    )
    ) {
        return state;
    }

    const result = {
        ...state,
    };

    const { groups } = action.payload;

    lodash.set(result, 'scene.groups', groups);

    return result;
}

export function loadGroups(state, action) {
    if (!action || action.type !== ACTIONS.PART11_LOAD_GROUPS) {
        return state;
    }

    const result = {
        ...state,
    };

    lodash.set(result, 'groups', action.payload.groups);

    return result;
}

export function loadGroup(state, action) {
    if (!action || action.type !== ACTIONS.PART11_LOAD_GROUP) {
        return state;
    }

    const result = { ...state };

    lodash.set(result, 'scene.group', action.payload.group);

    return result;
}

export function loadAvailableUsersForGroup(state, action) {
    if (!action || action.type !== ACTIONS.PART11_LOAD_AVAILABLE_USERS_FOR_GROUP) {
        return state;
    }

    const result = { ...state };

    lodash.set(result, 'scene.availableUsers', action.payload.users);

    return result;
}

export function loadDocumentTypesForGroup(state, action) {
    if (!action || action.type !== ACTIONS.PART11_LOAD_DOCUMENT_TYPES_FOR_GROUP) {
        return state;
    }

    const result = { ...state };

    lodash.set(result, 'scene.documentTypes', action.payload.documentTypes);

    return result;
}

export function clearGroupsScene(state, action) {
    if (!action || action.type !== ACTIONS.PART11_CLEAR_GROUPS_SCENE) {
        return state;
    }

    const result = { ...state };

    lodash.unset(result, 'groups');
    lodash.unset(result, 'users');
    lodash.unset(result, 'scene');

    return result;
}

export default composeReducers(
    loadGroupsInScene,
    loadGroups,
    loadAvailableUsersForGroup,
    loadDocumentTypesForGroup,
    loadGroup,
    clearGroupsScene,
);
